import { HimuraInject } from 'himura';
import { DataDelegate } from '../data.delegate';
import * as T_T from 'cryface';
import { CommonConfig } from '../../../configs/config.common';
import { IGetReportsParams } from '../../../models/reports';
import { UriGenerator } from '../uri.generator';
import * as moment from 'moment';
import { AxiosPromise } from '../../../utils/axios.promise';

@HimuraInject.NamedService('ReportsListDelegate')
export class ReportsListDelegate extends DataDelegate {
    constructor() {
        super('ReportsListDelegate');
        this.Data = {};
    }

    private _totalItems: number = 100;
    get TotalItems(): number {
        return this._totalItems;
    }
    set TotalItems(num: number) {
        this._totalItems = num;
    }

    private _currentPage: number = 100;
    get CurrentPage(): number {
        return this._currentPage;
    }
    set CurrentPage(num: number) {
        this._currentPage = num;
    }

    private _commonConfigs = new CommonConfig();

    public async getReportsSummary() {
        const today = await this._getTodayReports();
        const yesterday = await this._getYesterdayReports();
        const week = await this._getWeekReports();
        const month = await this._getMonthReport();
        if (today === 0 || yesterday === 0 || week === 0 || month === 0) {
            return 0;
        }
        this.Data.today = today.data.list;
        this.Data.yesterday = yesterday.data.list;
        this.Data.week = week.data.list;
        this.Data.month = month.data.list;
        return 1;
    }

    private async _getTodayReports() {
        const from: string = `${moment(new Date()).format(this._commonConfigs.dateFormat)} 00:00:00`;
        const to: string = `${moment(new Date()).format(this._commonConfigs.dateFormat)} 23:59:59`;
        const fetched = await this.getReportsCustomFunc({ pageSize: 10, startTime: from, endTime: to });
        if (T_T.simpleDetect(fetched) && fetched.errorCode === 200) {
            return fetched;
        } else {
            console.error(`Fetched Error Today Reports ${fetched.errorCode}`);
            return 0;
        }
    }

    private async _getYesterdayReports() {
        const from: string = `${moment(new Date()).add(-1, 'days').format(this._commonConfigs.dateFormat)} 00:00:00`;
        const to: string = `${moment(new Date()).add(-1, 'days').format(this._commonConfigs.dateFormat)} 23:59:59`;
        const fetched = await this.getReportsCustomFunc({ pageSize: 10, startTime: from, endTime: to });
        if (T_T.simpleDetect(fetched) && fetched.errorCode === 200) {
            return fetched;
        } else {
            console.error(`Fetched Error Yesterday Reports ${fetched.errorCode}`);
            return 0;
        }
    }

    private async _getWeekReports() {
        const from: string = `${moment(new Date()).weekday(1).format(this._commonConfigs.dateFormat)} 00:00:00`;
        const to: string = `${moment(new Date()).add(-1, 'days').format(this._commonConfigs.dateFormat)} 23:59:59`;
        const fetched = await this.getReportsCustomFunc({ pageSize: 10, startTime: from, endTime: to });
        if (T_T.simpleDetect(fetched) && fetched.errorCode === 200) {
            return fetched;
        } else {
            console.error(`Fetched Error Week Reports ${fetched.errorCode}`);
            return 0;
        }
    }

    private async _getMonthReport() {
        const date = new Date().getDate();
        const diff = date - 1;
        const from: string = `${moment(new Date()).add(-diff, 'days').format(this._commonConfigs.dateFormat)} 00:00:00`;
        const to: string = `${moment(new Date()).add(-1, 'days').format(this._commonConfigs.dateFormat)} 23:59:59`;
        const fetched = await this.getReportsCustomFunc({ pageSize: 10, startTime: from, endTime: to });
        if (T_T.simpleDetect(fetched) && fetched.errorCode === 200) {
            return fetched;
        } else {
            console.error(`Fetched Error Month Reports ${fetched.errorCode}`);
            return 0;
        }
    }

    private _generateUri(uriBase: string, params: IGetReportsParams) {
        const generator = new UriGenerator(uriBase);
        if (T_T.simpleDetect(params.addr)) {
            generator.setParam('addr', params.addr!);
        }
        if (T_T.simpleDetect(params.endTime)) {
            generator.setParam('endTime', params.endTime!);
        }
        if (T_T.simpleDetect(params.pageNo)) {
            generator.setParam('pageNo', params.pageNo!.toString());
        }
        if (T_T.simpleDetect(params.pageSize)) {
            generator.setParam('pageSize', params.pageSize!.toString());
        }
        if (T_T.simpleDetect(params.smsType)) {
            generator.setParam('smsType', params.smsType!);
        }
        if (T_T.simpleDetect(params.startTime)) {
            generator.setParam('startTime', params.startTime!.toString());
        }
        return generator.Uri;
    }

    public async getCustom(params: IGetReportsParams) {
        const fetched = await this.getReportsCustomFunc(params);
        if (T_T.simpleDetect(fetched) && fetched.errorCode === 200) {
            this.Data.custom = fetched.data.list;
            return 1;
        } else {
            console.error(fetched);
            return 0;
        }
    }

    public async getReportsCustomFunc(params: IGetReportsParams, page = 1) {
        const apiHost: string = this._commonConfigs.apiHost;
        const uri = this._generateUri(`${apiHost}/showing/message/pagination`, params);
        const fetched = await AxiosPromise.get(uri);
        this.TotalItems = fetched.data.total;
        this.CurrentPage = page;
        if (T_T.simpleDetect(fetched) && fetched.errorCode === 200) {
            return fetched;
        } else {
            return 0;
        }
    }

}
